import api from "../../../api";

export async function getAuthoringTemplateCatalog() {
  const response = await api.get("/activity-authoring/templates");
  return {
    methods: response.data?.methods || [],
  };
}

export async function listPerceptualTargets() {
  const response = await api.get("/activity-authoring/perceptual-targets");
  return (response.data?.groups || []).flatMap(group => group.targets || []);
}

export async function createPerceptualTarget(input) {
  const response = await api.post("/activity-authoring/perceptual-targets", input);
  return response.data?.target || null;
}

export async function listAuthoringActivities() {
  const response = await api.get("/activity-authoring/activities");
  if (!response.data || !Array.isArray(response.data.activities)) {
    throw new TypeError("ACTIVITY_LIBRARY_RESPONSE_INVALID");
  }
  return response.data.activities;
}

export async function getAuthoringActivity(activityId) {
  const response = await api.get(`/activity-authoring/activities/${activityId}`);
  return response.data?.activity || null;
}

export async function createActivityDraft(authoringState) {
  const response = await api.post("/activity-authoring/activities", authoringState);
  return response.data?.activity || null;
}

export async function saveActivityDraft(activityId, expectedRevision, authoringState) {
  const response = await api.put(`/activity-authoring/activities/${activityId}/draft`, {
    expectedRevision,
    authoringState,
  });
  return response.data?.activity || null;
}

export async function makeActivityReady(activityId, expectedRevision) {
  const response = await api.post(`/activity-authoring/activities/${activityId}/ready`, { expectedRevision });
  return response.data?.activity || null;
}

export async function validateActivityReadiness(activityId, expectedRevision) {
  const response = await api.post(`/activity-authoring/activities/${activityId}/validate`, { expectedRevision });
  return response.data || { valid: false };
}

export async function browseAuthoringStimuli({ search = "", vocalTask = "", cursor = null, limit = 24, methodKey = null } = {}) {
  const response = await api.get("/activity-authoring/stimuli", {
    params: { search: search || undefined, vocalTask: vocalTask || undefined, cursor: cursor || undefined, limit, methodKey: methodKey || undefined },
  });
  return response.data || { items: [], nextCursor: null };
}

export async function reResolveSelectedStimuli(stimulusInstanceIds, methodKey = null) {
  const response = await api.post("/activity-authoring/stimuli/re-resolve", { stimulusInstanceIds, methodKey });
  return response.data?.results || [];
}

export async function issueAuthoringPreviewMediaDescriptor({ stimulusInstanceId, activityId = "new-personal" }) {
  const response = await api.post("/activity-authoring/media-descriptor", {
    consumerContext: "FACILITATOR_AUTHORING_PREVIEW",
    activityId,
    stimulusInstanceId,
  });
  return response.data?.descriptor || null;
}

export async function createActivityVersion(activityId) {
  const response = await api.post(`/activity-authoring/activities/${activityId}/versions`);
  return response.data?.activity || null;
}

export async function duplicateActivity(activityId) {
  const response = await api.post(`/activity-authoring/activities/${activityId}/duplicate`);
  return response.data?.activity || null;
}

export async function archiveActivity(activityId) {
  const response = await api.post(`/activity-authoring/activities/${activityId}/archive`);
  return response.data || null;
}

export function authoringErrorCode(error) {
  const code = error?.response?.data?.error;
  return typeof code === "string" && code ? code : "ACTIVITY_AUTHORING_OPERATION_FAILED";
}
